<template>
    <home-template>
        <h2> Match Connection Error </h2>
        <p> {{ errorCodes[errorCode] }} </p>
        <router-link :to="homeRoute"> Back to main menu </router-link>
    </home-template>
</template>

<script>
import HomeTemplate from '../components/HomeTemplate.vue';
import { productionRoot } from '../config';
const config = require('../config');

export default {
    components: {
        HomeTemplate,
    },
    data() {
        return {
            errorCodes: {
                11: 'disconnected',
                21: "Couldn't find the game you are looking for!",
                22: "Couldn't reconnect to match. In order to do that, please enter this page from the browser you first used!",
                23: "Game is full! Sorry!",
                24: "Detected extra window. Please go back to your open window!"
            },
            homeRoute: config.production ? productionRoot : '/',
        }
    },
    props: {
        errorCode: {
            type: Number,
            required: true
        }
    },
}
</script>

<style scoped>
h2, p{
    color: rgba(238, 238, 238, 0.85);
}
a{
    color: #00ADB5;
    opacity: 0.8;
}
</style>